export const contactsData = {
    email: 'sudhanshupatil588@ gmail.com',
    phone: '7248913660 / 7038913660',
    address: 'Pusad, Maharashtra, India - 445204 ',

    sheetAPI: 'https://sheetdb.io/api/v1/22m75x6f1aphx'
}